import { render, staticRenderFns } from "./AiRequestsInfoText.vue?vue&type=template&id=6d033df7&scoped=true"
import script from "./AiRequestsInfoText.vue?vue&type=script&lang=js"
export * from "./AiRequestsInfoText.vue?vue&type=script&lang=js"
import style0 from "./AiRequestsInfoText.vue?vue&type=style&index=0&id=6d033df7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d033df7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d033df7')) {
      api.createRecord('6d033df7', component.options)
    } else {
      api.reload('6d033df7', component.options)
    }
    module.hot.accept("./AiRequestsInfoText.vue?vue&type=template&id=6d033df7&scoped=true", function () {
      api.rerender('6d033df7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/AiAssistance/Components/AiRequestsInfoText.vue"
export default component.exports